import { getCatalogItems, getProcessidsCatalogItems } from '../../../../services/api';
import { CatalogItems, ItemType, sortOrder, SortParams } from '../../../../services/api/types';

export const getAllCatalogItems = async (
  type: ItemType | Array<ItemType>,
  fetchAll = true,
  pagination = { page: 1, perPage: 10 },
  sort = { column: 'name', type: sortOrder.ASC } as SortParams<Partial<CatalogItems>>,
) => {
  try {
    const { data } = await getCatalogItems({ filters: { type: type }, pagination, sort, fetchAll });
    return data.data;
  } catch (error) {
    console.error('Error fetching materials:', error);
    return [];
  }
};

export const getProcessidsByMaterialIds = async (ids: number[]) => {
  if (ids.length === 0) {
    return [];
  }
  try {
    const { data } = await getProcessidsCatalogItems(ids);
    return data?.groupedProcessids || [];
  } catch (error) {
    console.error('Error fetching processIds:', error);
    return [];
  }
};
